import { render, staticRenderFns } from "./box-shadow.vue?vue&type=template&id=5c369da6&scoped=true&"
import script from "./box-shadow.vue?vue&type=script&lang=js&"
export * from "./box-shadow.vue?vue&type=script&lang=js&"
import style0 from "./box-shadow.vue?vue&type=style&index=0&id=5c369da6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c369da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c369da6')) {
      api.createRecord('5c369da6', component.options)
    } else {
      api.reload('5c369da6', component.options)
    }
    module.hot.accept("./box-shadow.vue?vue&type=template&id=5c369da6&scoped=true&", function () {
      api.rerender('5c369da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/lab/country-proj/components/box-shadow.vue"
export default component.exports